import { useState, useEffect } from "react";
import {
  Text,
  Flex,
  Box,
  Button,
  useDisclosure,
  Image,
  useToast,
  CloseButton, // ✅ add useToast
} from "@chakra-ui/react";
import useGetBags from "api/queries/useGetBags";
import { useUserContext } from "context/UserContext";
import Table from "components/table";
import CustomSelect from "components/select";
import Searchbar from "components/searchbar";
import RequestABagModal from "./Modal";
import { columns } from "./data";
import MainLayout from "components/mainLayout";
import RequestViewModal from "./RequestViewModal";
import HeaderDropdown from "components/dropdown";
import { SORT_NEWEST_FIRST, SORT_OLDEST_FIRST } from "utils/constants";
import { WarningIcon } from "@chakra-ui/icons";
import { useNavigate } from "react-router-dom";

const RequestABag = () => {
  const [sort, setSort] = useState("newest");
  const [search, setSearch] = useState("");
  const [viewRowData, setViewRowData] = useState({});
  const { user } = useUserContext();
  const [bags, setBags] = useState([]);

  const toast = useToast();
  const navigate = useNavigate();
  const {
    isOpen: isFormOpen,
    onOpen: onFormOpen,
    onClose: onFormClose,
  } = useDisclosure();

  const {
    isOpen: isViewModalOpen,
    onOpen: onViewModalOpen,
    onClose: onViewModalClose,
  } = useDisclosure();

  const bagsQuery = useGetBags({
    seller_id: user?.info?._id,
    search: search,
    sort: sort,
  });

  useEffect(() => {
    const data = bagsQuery?.data;
    if (!data) return;
    setBags(data);
  }, [bagsQuery?.data]);

  const handleRequestBagClick = () => {
    const { address, city, postcode } = user?.info || {};
    if (!address || !city || !postcode) {
      const toastId = toast({
        duration: 3000,
        isClosable: true,
        status: "error",
        position: "bottom",
        render: ({ onClose }) => (
          <Flex
            align="center"
            bg="red.500"
            color="white"
            p={3}
            borderRadius="md"
            fontWeight={500}
          >
            <WarningIcon mr={2} />
  
            <Box flex="1">
              <Text fontSize="14px" fontFamily="PlusJakartaSansMedium">
                Please complete your address on{" "}
                <Text
                  as="span"
                  textDecoration="underline"
                  cursor="pointer"
                  fontWeight="bold"
                  onClick={() => {
                    navigate("/profile");
                    toast.close(toastId); 
                  }}
                >
                  Profile
                </Text>{" "}
                screen!
              </Text>
            </Box>
  
            <CloseButton onClick={onClose} color="white" />
          </Flex>
        ),
      });
      return; 
    }
    onFormOpen();
  };
  

  const handleViewClick = (row) => {
    setViewRowData(row);
    onViewModalOpen();
  };

  return (
    <MainLayout>
      <Flex minH={"100vh"} h={"100%"} direction={"column"}>
        <Box>
          <Flex
            bg="white"
            padding={8}
            align={"center"}
            justify={"space-between"}
          >
            <Flex alignItems={"center"}>
              <Text
                fontFamily={"PlusJakartaSansBold"}
                fontSize={"16px"}
                lineHeight={"16px"}
                textTransform={"uppercase"}
              >
                Request a bag
              </Text>
              <Image
                src={require("assets/svgs/info-circle.svg").default}
                pos={"relative"}
                bottom={"1px"}
                mx={2}
                _hover={{ cursor: "pointer" }}
              />
            </Flex>
            <Flex gap={2} justifyContent={"flex-end"}>
              <Button
                onClick={handleRequestBagClick} // ✅ use custom handler
                w={"140px"}
                py={6}
                bg={"#1C1C1C"}
                borderRadius={"12px"}
                color={"white"}
                textTransform={"capitalize"}
                alignSelf={"flex-end"}
                alignItems={"center"}
                justifyContent={"center"}
                fontSize={"12px"}
                fontFamily={"PlusJakartaSansBold"}
              >
                <Image
                  src={require("assets/svgs/box.svg").default}
                  width={"16px"}
                  height={"16px"}
                  pos={"relative"}
                  mr={2}
                  _hover={{ cursor: "pointer" }}
                />
                Request Bag
              </Button>
              <HeaderDropdown />
            </Flex>
          </Flex>
        </Box>

        <Flex bg={"#f8fbff"} padding={4} height={"100%"} gap={2}>
          <Flex flex={1} direction={"column"} padding={4}>
            <Flex justify={"space-between"} alignItems={"center"} mb={4}>
              <Searchbar onChange={setSearch} title={"Search"} />
              <Flex align={"center"} gap={2}>
                <CustomSelect
                  label={"Sort"}
                  onChange={setSort}
                  style={{ maxWidth: "200px" }}
                  inputStyle={{
                    border: "none",
                    background: "#fff",
                    color: "#898989",
                    fontSize: "14px",
                    fontFamily: "PlusJakartaSansMedium",
                  }}
                >
                  <option value={SORT_NEWEST_FIRST}>Newest First</option>
                  <option value={SORT_OLDEST_FIRST}>Oldest First</option>
                </CustomSelect>
              </Flex>
            </Flex>
            <Box minW={"100%"} w={"1px"} overflowX={"auto"}>
              <Table columns={columns(handleViewClick)} data={bags} />
            </Box>
          </Flex>
        </Flex>

        <RequestViewModal
          onClose={onViewModalClose}
          isOpen={isViewModalOpen}
          data={viewRowData}
        />
        <RequestABagModal onClose={onFormClose} isOpen={isFormOpen} />
      </Flex>
    </MainLayout>
  );
};

export default RequestABag;
